import { type Board, type Clip } from '@air/api/types';

export const droppedOnAsset = (data: unknown): data is Clip => !!(data as Clip).assetId;
export const droppedOnBoard = (data: unknown): data is Board => !(data as Clip).assetId;
export const droppedOnRoot = (data: unknown) => !data;
